module.exports = __webpack_public_path__ + "static/img/ethnicity-stay-gap.a260e14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/research/research-page/ethnicity-stay-gap.png
// module id = UnDw
// module chunks = 0